import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../components-v2/Theme/theme';
import { shadowMd } from '../../styles/shadows';
import { background, borderColor, brandPrimary, header, titles, warningDark, warningLight } from '../../styles/colors';

// Two panes: Lev in a fixed column, the site preview filling whatever is left. Not AppDrawer — that caps at
// 800px and ~30 screens depend on the cap; the editor wants a real split.
export const styleSheet = StyleSheet.create({
	page: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		height: '100%',
		minHeight: 0,
		minWidth: 0,
		background,
	},
	tabList: {
		background: THEME.colors.background.light,
		flexShrink: 0,
		paddingLeft: SPACE[8],
	},
	tabPanel: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		minHeight: 0,
		minWidth: 0,
		':is([data-state="inactive"])': {
			display: 'none',
		},
	},
	hidden: {
		display: 'none',
	},
	previewPane: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 0,
		minHeight: 0,
		flex: 1,
	},
	toolbar: {
		alignItems: 'center',
		borderBottom: `1px solid ${borderColor}`,
		display: 'flex',
		gap: 12,
		padding: `${SPACE[12]}px ${SPACE[16]}px`,
		background: THEME.colors.background.light,
	},
	toolbarTitle: {
		color: titles,
		fontSize: 16,
		fontWeight: 600,
		marginRight: 'auto',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	pageSelect: {
		// The viewport toggle sets the row's height and its items aren't reachable from here, so the select and the
		// button match it rather than the other way round.
		height: 40,
		maxWidth: 260,
	},
	pageSelectLabel: {
		...THEME.common.truncate,
	},
	banner: {
		alignItems: 'center',
		display: 'flex',
		fontSize: 13,
		gap: 8,
		padding: `${SPACE[8]}px ${SPACE[16]}px`,
	},
	pendingBanner: {
		background: warningLight,
		color: warningDark,
	},
	lockBanner: {
		background: THEME.colors.background.main,
		color: titles,
	},
	pickingBanner: {
		background: THEME.colors.background.main,
		color: titles,
	},
	frameHost: {
		background: THEME.colors.background.main,
		display: 'flex',
		flex: 1,
		justifyContent: 'center',
		minHeight: 0,
		overflow: 'auto',
		padding: 16,
		// Offset parent for the loading scrim.
		position: 'relative',
	},
	frameLoading: {
		alignItems: 'center',
		// Scrim over the outgoing page; needs alpha, so it can't come from a theme colour.
		background: 'rgba(255, 255, 255, 0.65)',
		display: 'flex',
		inset: 0,
		justifyContent: 'center',
		position: 'absolute',
	},
	selectionAnchor: {
		outline: `2px solid ${THEME.colors.primary.main}`,
		outlineOffset: 2,
		pointerEvents: 'none',
		position: 'absolute',
	},
	selectionForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		width: 280,
	},
	selectionActions: {
		display: 'flex',
		gap: SPACE[8],
		justifyContent: 'flex-end',
	},
	// Wraps the frame so the selection anchor can use the frame-reported rect as-is, with no offset maths and no
	// ref read during render to find where the frame currently sits.
	frameWrap: {
		flex: '0 0 auto',
		height: '100%',
		maxWidth: '100%',
		position: 'relative',
		transition: 'width 160ms ease',
	},
	frame: {
		background: THEME.colors.background.light,
		border: 'none',
		boxShadow: shadowMd,
		display: 'block',
		height: '100%',
		width: '100%',
	},
	empty: {
		alignItems: 'center',
		color: header,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 8,
		justifyContent: 'center',
		padding: 32,
		textAlign: 'center',
	},
	emptyTitle: {
		color: titles,
		fontSize: 18,
		fontWeight: 600,
	},
	openLink: {
		color: brandPrimary,
		fontSize: 13,
		whiteSpace: 'nowrap',
	},
});
